import type { BarChartYAxisTicksConfiguration } from "~/core/models/BarChartYAxisTicksConfiguration.interface";

export function barChartComputeYAxisTicks(
  data: Record<string, number>,
): BarChartYAxisTicksConfiguration {
  const values = Object.values(data);
  const maxValue = Math.max(...values);
  const minValue = 0;

  // Special case: all values are 0
  if (maxValue === 0) {
    return {
      min: 0,
      max: 4,
      stepSize: 1,
    };
  }

  let stepSize = 1;
  let roundedMax = 0;
  const maxIterations = 1000; // Safety limit
  let iterations = 0;

  while (iterations < maxIterations) {
    const candidateMax = Math.ceil(maxValue / stepSize) * stepSize;
    if ((candidateMax - minValue) % 4 === 0) {
      roundedMax = candidateMax;
      stepSize = (roundedMax - minValue) / 4;
      break;
    }
    stepSize++;
    iterations++;
  }

  // Fallback if no valid stepSize found
  if (iterations === maxIterations) {
    roundedMax = Math.ceil(maxValue / 10) * 10;
    stepSize = (roundedMax - minValue) / 4;
  }

  return {
    min: minValue,
    max: roundedMax,
    stepSize,
  };
}
